import { klona } from 'klona';

function stateToResult(state, right) {
    if (state === 'left') {
        return right ? 'lost' : 'won';
    } else if (state === 'right') {
        return right ? 'won' : 'lost';
    } else if (state === 'upcoming') {
        return 'picked';
    } else {
        return null;
    }
}

function stateToMapResult(state) {
    if (state === 'left') {
        return state;
    } else if (state === 'right') {
        return state;
    } else if (state === 'upcoming') {
        return 'picked';
    } else {
        return null;
    }
}

export function mergeCivDraftView(draftView, matchGames, matchRedraftAfter, removeSnipe) {
    if (!draftView.host || !draftView.guest) return draftView;

    let result = klona(draftView);

    for (let i = 0; i < result.host.length; i++)
    {
        if (result.host[i].action === 'snipe') {
            const sniped = result?.guest.find(item => item.action === 'pick' && item.option === result.host[i].option);
			if(!sniped) return;
            sniped.result = 'sniped';
            removeSnipe && result.host.splice(i--);
        }
    }
    
    for (let i = 0; i < result.guest.length; i++)
	{
		if (result.guest[i].action === 'snipe') {
			const sniped = result?.host.find(item => item.action === 'pick' && item.option === result.guest[i].option);
			if(!sniped) return;
            sniped.result = 'sniped';
            removeSnipe && result.guest.splice(i--);
        }
    }

    if (matchRedraftAfter) {
        matchGames = matchGames.slice(matchRedraftAfter);
    }

    matchGames.forEach(game => {
        game.leftCivs.forEach(civ => {
            let hostPick = result?.host.find(v => v.action === 'pick' && v.option === civ);
            if (!hostPick) {
                console.log(`Couldn't find ${civ}`, result.host);
            } else {
                hostPick.result = stateToResult(game.state, false);
            }
        })

        game.rightCivs.forEach(civ => {
            let guestPick = result.guest.find(v => v.action === 'pick' && v.option === civ);
            if (!guestPick) {
                console.log(`Couldn't find ${civ}`);
            } else {
                guestPick.result = stateToResult(game.state, true);
            }
        })
    });

    console.log(result);

    return result;
}

export function mergeMapDraftView(draftView, matchGames, matchRedraftAfter) {
    if (!draftView.host || !draftView.guest) return draftView;

    let result = klona(draftView);

    if (matchRedraftAfter) {
        matchGames = matchGames.slice(matchRedraftAfter);
    }

    matchGames.forEach(game => {
        const map = game.map;
        if (map) {
            let hostPick = [...result.host, ...result.guest].find(v => v.action === 'pick' && v.option === map);
            if (!hostPick) {
                console.log(`Couldn't find ${map}`, result.host);
            } else {
                hostPick.result = stateToMapResult(game.state);
            }
        }
    });

    return result;
}
